import { Base64 } from 'js-base64';

const AccessTokenFieldName = 'access_token';
const RefreshTokenFieldName = 'refresh_token';

export class AuthTokenStorage {
  static setTokens(accessToken, refreshToken) {
    sessionStorage.setItem(AccessTokenFieldName, accessToken);
    sessionStorage.setItem(RefreshTokenFieldName, refreshToken);
  }

  static isAccessTokenDefined() {
    return sessionStorage.getItem(AccessTokenFieldName) !== null;
  }

  static isRefreshTokenDefined() {
    return sessionStorage.getItem(RefreshTokenFieldName) !== null;
  }

  static removeTokens() {
    sessionStorage.removeItem(AccessTokenFieldName);
    sessionStorage.removeItem(RefreshTokenFieldName);
  }

  static get accessToken() {
    return sessionStorage.getItem(AccessTokenFieldName);
  }

  static get refreshToken() {
    return sessionStorage.getItem(RefreshTokenFieldName);
  }

}

export class JWToken {
  constructor(token) {
    this.token = token;
    this.exp = null;
    this.login = null;
    this.allowWrite = null;
  }

  parse() {
    let base64Url = this.token.split('.')[1];
    let base64 = base64Url.replace('-', '+').replace('_', '/');
    let json = JSON.parse(Base64.decode(base64));
    if (json.exp === undefined)
      return false;
    this.exp = json.exp;
    if (json.login === undefined)
      return false;
    this.login = json.login;
    if (json.allowWrite === undefined)
      return false;
    this.allowWrite = json.allowWrite;
    return true;
  }

  isExpired() {
    return this.exp < Date.now() / 1000;
  }
}



// WEBPACK FOOTER //
// ./src/common/authTokenStorage.js